import { parseStoredUser, getCurrentUser, getCurrentUserId } from './authSession'

/**
 * Platform staff check:
 * Returns true if the user has any platform role (SUPER_ADMIN, SUPPORT_AGENT, DEVELOPER).
 */
export const isPlatformStaff = (user) => {
  const role = user?.platformRole ?? user?.platform_role
  return Boolean(role)
}

/**
 * Super Admin check:
 * Returns true if the user is a platform SUPER_ADMIN.
 */
export const isSuperAdmin = (user) => {
  const role = user?.platformRole ?? user?.platform_role
  return role === 'SUPER_ADMIN'
}

/**
 * Platform Agent check:
 * Returns true if the user is a SUPPORT_AGENT or DEVELOPER.
 */
export const isPlatformAgent = (user) => {
  const role = user?.platformRole ?? user?.platform_role
  return ['SUPPORT_AGENT', 'DEVELOPER'].includes(role)
}

/**
 * Assigned Agent check:
 * Returns true if this specific ticket is assigned to the current platform agent.
 */
export const isAssignedAgent = (ticket, user) => {
  if (!isPlatformAgent(user)) return false
  const assignedId = Number(ticket?.assignedAgentId || 0)
  const currentUserId = Number(user?.userId ?? user?.user_id ?? user?.id ?? 0)
  return assignedId > 0 && assignedId === currentUserId
}

export { parseStoredUser, getCurrentUser, getCurrentUserId }
